export class CaseRegionModel{
    id: number;
    name: string;
}